import kbpgp from 'kbpgp'
import {promisify} from 'utils/promise.utils'

export default async (keys, passphrase) => {
  // create base key manager with public key
  const km = await promisify(
    kbpgp.KeyManager.import_from_armored_pgp,
    kbpgp.KeyManager
  )({armored: keys.public})

  // add private key
  if (keys.private) {
    await promisify(km.merge_pgp_private, km)({armored: keys.private})
  }

  // unlock the key
  if (km.is_pgp_locked()) {
    await promisify(km.unlock_pgp, km)({passphrase})
  }

  return km
}
